var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationDoctor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M21 72h2v-8h-2zM57 72h2v-5l-2 1zM13 72h-2V57c0-6.488 6.871-9.672 13.616-11.926l5.88-2.94c1.158-.78 2.318-1.803 2.504-2.206V37h2v3c0 1.269-1.874 2.784-3.445 3.832a1.05 1.05 0 01-.108.063l-6 3a.876.876 0 01-.131.053C19.226 48.979 13 51.761 13 57M69 72h-2V57c0-5.239-6.226-8.021-12.316-10.052a.876.876 0 01-.131-.053l-6-3a1.05 1.05 0 01-.108-.063C46.874 42.784 45 41.269 45 40v-3h2v2.928c.186.403 1.346 1.426 2.504 2.206l5.88 2.94C62.129 47.328 69 50.512 69 57M29 26h1v-2h-1z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 41c-7.32 0-10.826-7.949-10.994-13.579l-.713-.714A.996.996 0 0128 26v-4h2v3.586l.707.707A.996.996 0 0131 27c0 4.84 2.86 12 9 12 6.14 0 9-7.16 9-12 0-.266.105-.52.293-.707l.707-.707V22h2v4c0 .266-.105.52-.293.707l-.713.714C50.826 33.051 47.32 41 40 41",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.414 20h21.172l.353-.354-.93-6.504C49.882 12.433 49.267 10 47 10H33c-2 0-2.753 2.018-3.023 3.22l-.915 6.426.353.354zM51 22H29a.996.996 0 01-.707-.293l-1-1a1.001 1.001 0 01-.283-.849l1-7C28.699 9.787 30.559 8 33 8h14c2.537 0 4.447 1.848 4.984 4.822l1.006 7.036c.044.312-.06.626-.283.849l-1 1A.996.996 0 0151 22z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M39 18h2v-6h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M37 16h6v-2h-6z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 48c-5.701 0-10-2.149-10-5h2c0 1.224 3.116 3 8 3s8-1.776 8-3h2c0 2.851-4.299 5-10 5",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.53 55.883C38.855 55.524 24 45.968 24 35v-7c0-2.757 1.243-4 4-4v2c-1.654 0-2 .346-2 2v7c0 8.792 11.409 17.369 14 18.854C42.591 52.369 54 43.792 54 35v-7c0-1.654-.346-2-2-2v-2c2.757 0 4 1.243 4 4v7c0 10.968-14.855 20.524-15.53 20.883a1.007 1.007 0 01-.94 0z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 56c0 5.514 4.486 10 10 10s10-4.486 10-10V43h2v13c0 6.617-5.383 12-12 12s-12-5.383-12-12h2z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 38c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationDoctor;